<div class="page-layout-container">

    <div class="title-group">
        <h1> Employee Access List </h1>
    </div>

    <div>

        <mat-form-field appearance="standard">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="search with Employee id, name,.." #input>
        </mat-form-field>
        
        <div *ngIf="successMessage" class="alert alert-danger">{{ successMessage }}</div>
        <div *ngIf="errorDescription" class="alert alert-success">{{ errorDescription }}</div>


        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

            <!-- Position Column -->
            <ng-container matColumnDef="userName">
                <th mat-header-cell *matHeaderCellDef> User Name </th>
                <td mat-cell *matCellDef="let element"> {{element.userName}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.status}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef> Role </th>
                <td mat-cell *matCellDef="let element"> {{element.role}} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions</th>
                <td mat-cell *matCellDef="let element" (click)="deleteUser(element)">
                    <button mat-button>Delete</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
</div>